import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { uniqBy } from 'lodash';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment-timezone';

import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { Button } from 'reactstrap';

import { fpBookImplicitAsync, getSummaryOfBookings } from '../../state/services/bookingService';
// import { fpBookImplicit } from '../../state/services/bookingService';
// Constants
import { timeDiff } from '../../commons/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { API_HOST, HTTP_PROTOCOL } from '../../config';

class ManifestSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            needTruck: false,
            manifest_timestamp: null,
            missedScans: {},
            reason: '',
            reasonChecked: false,
        };

        moment.tz.setDefault('Australia/Sydney');
        this.tzOffset = new Date().getTimezoneOffset() === 0 ? 0 : -1 * new Date().getTimezoneOffset() / 60;
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleSlider: PropTypes.func.isRequired,
        onCreateOrder: PropTypes.func.isRequired,
        getSummaryOfBookings: PropTypes.func.isRequired,
        fpBook: PropTypes.func.isRequired,
        manifestSummary: PropTypes.object,
        selectedBookings: PropTypes.array,
    };

    notify = (text) => toast(text);

    UNSAFE_componentWillReceiveProps(newProps) {
        if (!this.props.isOpen && newProps.isOpen) { // Every time Slider is opened
            const bookingIds = newProps.selectedBookings.map(booking => booking.id);
            this.props.getSummaryOfBookings(bookingIds, 'manifest');

            // Set initial manifest
            this.setState({manifest_timestamp: moment()});
            this.fetchMissedScannedOrders();
        }
    }

    fetchMissedScannedOrders = () => {
        const selectedPkIds = this.props.selectedBookings.map(booking => booking.pk_booking_id);
        const token = localStorage.getItem('token');
        let options = {
            method: 'post',
            url: HTTP_PROTOCOL + '://' + API_HOST + '/bookings/get_missed_scans/',
            headers: {'Authorization': 'JWT ' + token },
            data: {
                bookingPkIds: selectedPkIds,
            }
        };

        axios(options)
            .then(({data}) => {
                console.log({data});
                this.setState({missedScans: data});
            })
            .catch(error => {
                toast.error('Failed to fetch missed scans: ' + error);
            });
    }

    onInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({needTruck: value});
    }

    onChangeDateTime(date, fieldName) {
        let conveted_date = null;
        if (date) {
            conveted_date = moment(date).add(this.tzOffset, 'h');           // Current -> UTC
            conveted_date = conveted_date.add(timeDiff, 'h');                   // UTC -> Sydney
        }

        if (fieldName === 'manifest_timestamp') {
            this.setState({manifest_timestamp: conveted_date});
        }
    }

    async onClickBookAllBtn() {
        const {selectedBookings} = this.props;
        let booknigs2Book = [];

        for (let i = 0; i < selectedBookings.length; i++) {
            const booking = selectedBookings[i];

            if (!booking.b_dateBookedDate) {
                booknigs2Book.push(booking);
            }
        }

        const promises = booknigs2Book.map((booking, i) =>
            this.props.fpBook(booking.id, booking.vx_freight_provider, i, booknigs2Book.length)
        );

        try {
            await Promise.all(promises);
            return 'success';
        } catch (error) {
            console.log('Error while booking order:', error);
            return error.message;
        }
    }

    onCreateManifest = async (bookingIds, firstFP) => {
        if (firstFP === 'Team Global Express') {
            const book_all_result = await this.onClickBookAllBtn();
            if (book_all_result !== 'success') {
                toast.error(`Error while booking order:${book_all_result}`);
                return;
            }
        }
        const {needTruck, manifest_timestamp} = this.state;
        this.props.onCreateOrder(bookingIds, firstFP, needTruck, manifest_timestamp, this.state.reason);
    }

    render() {
        const {isOpen, selectedBookings, manifestSummary} = this.props;
        const {needTruck, manifest_timestamp, missedScans} = this.state;

        const puAvailFromDateCnt = uniqBy(selectedBookings, 'puPickUpAvailFrom_Date').length;
        const fpCnt = uniqBy(selectedBookings, (each) => `${each.vx_freight_provider}(${each.vx_serviceName})`).length;
        // let bookedCnt = selectedBookings.filter(booking => booking.b_dateBookedDate).length;
        // let notBookedCnt = selectedBookings.length - bookedCnt;
        const bookingIds = selectedBookings.map(booking => booking.id);
        const summaryList = [];
        let firstFP = 0;
        let notScannedOrderNos = [];

        if (bookingIds.length > 0) {
            firstFP = selectedBookings[0].vx_freight_provider;
        }

        if (manifestSummary) {
            let index = 0;
            for (const fp in manifestSummary.fps) {
                index += 1;

                summaryList.push(
                    <div key={index}>
                        <label>
                            <h5>#{index}</h5>
                            <strong>Freight Provider name:</strong> {fp}<br />
                            <strong>Booking Ids:</strong> {manifestSummary.fps[fp]['bookingIds'].join(',')}<br />
                            <strong>Order Count:</strong> {manifestSummary.fps[fp]['orderCnt']}<br />
                            <strong>Total Quantity:</strong> {manifestSummary.fps[fp]['totalQty']}<br />
                            <strong>Total KGs:</strong> {manifestSummary.fps[fp]['totalKgs'].toFixed(3)} (KG)<br />
                            <strong>Total Cubic Meter:</strong> {manifestSummary.fps[fp]['totalCubicMeter'].toFixed(3)} (m3)
                        </label>
                        <hr />
                    </div>
                );
            }

            const stats = manifestSummary.stats;
            for (const bookingId in stats) {
                if (stats[bookingId]['scanned_lines_count'] === 0) {
                    notScannedOrderNos.push(stats[bookingId]['b_client_order_num']);
                }
            }
        }

        // Can Manifest Checkpoint
        let canManifest = true;
        
        // if ((fpCnt === 1 && firstFP !== 'Team Global Express') ||
        //     (fpCnt === 1 && firstFP === 'Team Global Express' && notBookedCnt === 0)
        // ) {
        //     canManifest = true;
        // }

        // if (fpCnt === 1 && firstFP === 'Direct Freight') {
        //     if (notScannedOrderNos.length === 0) {
        //         canManifest = true;
        //     } else {
        //         canManifest = false;
        //     }
        // }

        if (puAvailFromDateCnt > 1) {
            canManifest = false;
        }

        if (fpCnt !== 1) {
            canManifest = false;
        }

        if (Object.keys(missedScans).length > 0){
            if (!this.state.reasonChecked) {
                canManifest = false;
            }
            if (this.state.reason.trim() === '') {
                canManifest = false;
            }
        }

        const bookList = selectedBookings.map((booking, index) => {
            let action = 'Done';
            if (booking.b_dateBookedDate) {
                action = 'Done';
            } else {
                action = 'In Queue';
            }

            return (<tr key={index}>
                <td>{booking.b_bookingID_Visual}</td>
                <td>{booking.b_client_order_num}</td>
                <td>{booking.b_status}</td>
                <td>{booking.puPickUpAvailFrom_Date}</td>
                <td>{action}</td>
                <td>
                    {!missedScans[booking.pk_booking_id] ? <span className='badge badge-success w-100'>Yes</span> : <span className='badge badge-danger w-100'>No</span>}
                </td>
                <td>{missedScans[booking.pk_booking_id] && missedScans[booking.pk_booking_id].map(each => <div key={each.sscc}>{each.sscc}</div>)}</td>
            </tr>);
        });

        return (
            <SlidingPane
                className='manifest-slider'
                overlayClassName='manifest-slider-overlay'
                isOpen={isOpen}
                title='Manifest Slider'
                subtitle=''
                onRequestClose={() => this.props.toggleSlider()}
            >
                <h4>Please correct any red text issues before manifesting.</h4>
                <hr />
                <label>
                    <span className={fpCnt > 1 ? 'red' : ''}>
                        # {fpCnt} `Freight Provider Service(s)`; {fpCnt !== 1 ? 'DME does not support multi-FP Service manifest' : ''}
                    </span><br />
                    <span className={puAvailFromDateCnt > 1 ? 'red' : ''}>
                        # There are {puAvailFromDateCnt} Pickup available from dates. Please make sure all selected bookings to be manifested have a date set for today.
                    </span><br />
                    {(firstFP === 'Direct Freight' && notScannedOrderNos.length > 0) &&
                        <span className='red'>
                            # The following orders do not have any items to send on the {'Actual Packed / Scanned'} tab. Please correct these to continue - {notScannedOrderNos.join(', ')}
                        </span>
                    }
                </label>
                <hr />
                {summaryList}
                {(firstFP === 'TNT' || firstFP === 'Direct Freight') &&
                    <label>
                        <p className='need-truck'>Need Truck?</p>
                        <input
                            type="checkbox"
                            name="needTruck"
                            className="checkbox"
                            checked={needTruck}
                            onChange={(e) => this.onInputChange(e)}
                        />
                    </label>
                }
                {(firstFP === 'TNT' || firstFP === 'Direct Freight') && <hr />}
                <label>
                    <p className='manifest-timestamp'>Manifest datetime (Sydney time):</p>
                    <DateTimePicker
                        onChange={(date) => this.onChangeDateTime(date, 'manifest_timestamp')}
                        value={manifest_timestamp ? new Date(moment(manifest_timestamp).toDate().toLocaleString('en-US', {timeZone: 'Australia/Sydney'})) : null}
                        format={'dd/MM/yyyy HH:mm'}
                    />
                </label>
                <hr />
                <div className="progress-b4-manifest">
                    <hr />
                    <table className="table table-hover table-bordered table-striped w-100 overflow-auto">
                        <thead>
                            <tr>
                                <th>Booking ID</th>
                                <th>Order No</th>
                                <th>Status</th>
                                <th>PU Avail From Date</th>
                                <th>Action</th>
                                <th>Fully Scanned</th>
                                <th>Missed SSCCs</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bookList}
                        </tbody>
                    </table>
                </div>
                {
                    Object.keys(missedScans).length > 0 && 
                    (
                        <div>
                            <label className='d-flex align-items-center'>
                                <input
                                    type='checkbox'
                                    required
                                    checked={this.state.reasonChecked}
                                    onChange={(e) => this.setState({reasonChecked: e.target.checked})}
                                />
                                <span className='mt-2 ml-3'>Please tick here if you want to manifest with incomplete scans.</span>
                            </label>
                            <p>Please provide reason(s) why the scans are missing for above order(s):</p>
                            <textarea
                                className='form-control'
                                placeholder='Enter reason here'
                                onChange={(e) => this.setState({reason: e.target.value})}
                                value={this.state.reason}
                            ></textarea>
                        </div>
                    )
                }
                <Button
                    color="primary"
                    disabled={!canManifest}
                    title={fpCnt !== 1 ? 'DME does not support multi-FP manifest' : 'Create manifest'}
                    onClick={() => this.onCreateManifest(bookingIds, firstFP)}
                >
                    Create Manifest
                </Button>
                <Button color="secondary" onClick={() => this.props.toggleSlider()}>Cancel</Button>
            </SlidingPane>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        manifestSummary: state.booking.manifestSummary,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSummaryOfBookings: (bookingIds, from) => dispatch(getSummaryOfBookings(bookingIds, from)),
        fpBook: async (bookingId, vx_freight_provider, bIndex, bookingsCnt) => await dispatch(fpBookImplicitAsync(bookingId, vx_freight_provider, bIndex, bookingsCnt)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManifestSlider));



// WEBPACK FOOTER //
// ./src/components/Sliders/ManifestSlider.js